import { Component, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { PDFDocument } from 'pdf-lib';
import { LFDAPIService } from 'src/app/core/services/api';
import { ResumeFileDetails } from 'src/app/core/interfaces/ResumeFileDetails';
import { UserDetail } from 'src/app/core/interfaces/User';

@Component({
  selector: 'app-upload-resume',
  templateUrl: './upload-resume.component.html',
  styleUrls: ['./upload-resume.component.less']
})

export class UploadResumeComponent {
  selectedFile: File | null | undefined;
  uploadMessage: string = '';
  selectedFileName: string | undefined;
  activeUpload: boolean = true;
  resumeUploadSuccess: boolean = false;
  resumePagecount: any = 0;
  uploading:boolean = false;
  isLoader:boolean=false;
  @Output() uncheckDisclaimer = new EventEmitter<boolean>;


  constructor(private apiService: LFDAPIService) { }

  ngOnInit() {
    this.uploadMessage = '';
    this.activeUpload = true;
    this.resumeUploadSuccess = false;
    this.selectedFile = null;
  }
  onFileSelected(info: NzUploadChangeParam): void {
    const file = info.file.originFileObj as File;
    const fileReader = new FileReader();
    this.uploadMessage = '';
    fileReader.onload = async () => {
      const pdfDoc = await PDFDocument.load(fileReader.result as ArrayBuffer);
      try {
        this.resumePagecount = pdfDoc.getPageCount();
        if (file && file.type !== 'application/pdf' && this.resumePagecount > 3) {
          this.uploadMessage = 'Only PDF files are allowed and 3 pages max';
          this.activeUpload = true;
          this.selectedFile = null;
          this.uploading = false;
        }
        else if (file && file.type !== 'application/pdf') {
          this.uploadMessage = 'Only PDF files are allowed.';
          this.activeUpload = true;
        } else if (file && this.resumePagecount > 3) {
          this.uploadMessage = 'PDF must not exceed 3 pages. This document contains ' + this.resumePagecount + ' pages.';
        }
        else {
          this.selectedFile = file;
          this.selectedFileName = this.selectedFile?.name;
          this.activeUpload = false;
        }
      } catch (error) {
        this.uploadMessage = 'Error uploading document.';
        this.selectedFile = null;
      }
    }
    fileReader.readAsArrayBuffer(file)
  }

  uploadFile(fileDetails: ResumeFileDetails): void {
    this.uploading = true;
    this.isLoader = true;
    this.apiService.uploadResume(fileDetails).subscribe({
      next: (res) => {
        console.log('Upload success:', res);
        this.resumeUploadSuccess = true;
        this.selectedFile = null;
        this.uploading = false;
        this.isLoader = false;
      },
      error: (err) => {
          console.error('Upload error:', err);
          this.uploadMessage = 'Error uploading resume.';
          this.uploading = false;
          this.isLoader = false;
        }
    });
  }

  uploadResume(): void {
    if (this.selectedFile instanceof File) {
      const user = sessionStorage.getItem('userdetail');
      if (user !== null) {
        try {
          const userDetails = JSON.parse(user);
          console.log(userDetails);
          const email = userDetails.email;
          const fileDetails: ResumeFileDetails = {
            file: this.selectedFile,
            userEmail: email
          };
          this.uploadFile(fileDetails);
        } catch (e) {
          console.error('Failed to parse userDetails from sessionStorage:', e);
        }
      }
    } else {
      this.uploadMessage = 'No valid file selected for upload.';
    }
  }
  removeFile() {
    this.selectedFile = null;
    this.selectedFileName = undefined;
    this.uploadMessage = '';
    this.activeUpload = true;
  }
  closePopup(): void {
    this.uncheckDisclaimer.emit(false);
    this.resumeUploadSuccess = false;
    this.selectedFile = null;
    this.uploadMessage = '';
    this.activeUpload = true;
    this.selectedFileName = undefined;
  }
}
